"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Warning = void 0;
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
/**
 * Source: https://github.com/microsoft/fluentui-system-icons/blob/master/icons.md
 * name: "Person (Filled)"
 */
exports.Warning = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, { width: "22", height: "19", viewBox: "0 0 22 19", fill: "none" },
    React.createElement("path", { d: "M9.2681 1C10.0379 -0.333333 11.9624 -0.333333 12.7322 1L21.3925 16C22.1623 17.3333 21.2 19 19.6604 19H2.3399C0.800297 19 -0.161953 17.3333 0.607847 16L9.2681 1Z", fill: common_styles_1.neutral }),
    React.createElement("path", { d: "M10 10C10 9.44772 10.4477 9 11 9C11.5523 9 12 9.44772 12 10V15C12 15.5523 11.5523 16 11 16C10.4477 16 10 15.5523 10 15V10Z", fill: props.fill || common_styles_1.white }),
    React.createElement("path", { d: "M10 7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7C12 7.55228 11.5523 8 11 8C10.4477 8 10 7.55228 10 7Z", fill: props.fill || common_styles_1.white }))); };
//# sourceMappingURL=warning.js.map